import { revenueByMonth, sumRevenue } from "@/pages/admin/dashboard/dashboardData";
import { formatCompactRupees, formatRupees } from "@/pages/admin/format";

export default function RevenueAnalytics() {
  const totals = sumRevenue(revenueByMonth);
  const net = totals.gross - totals.refunds;

  const rows = [
    { label: "Gross Revenue", value: totals.gross, bar: "bg-primary-500" },
    { label: "Rythugaru Commission", value: totals.commission, bar: "bg-accent-500" },
    { label: "Farmer Revenue", value: totals.farmer, bar: "bg-secondary-500" },
    { label: "Refunds", value: totals.refunds, bar: "bg-foreground-400" },
    { label: "Net Revenue", value: net, bar: "bg-primary-700" },
  ];
  const max = Math.max(1, totals.gross);
  const monthMax = Math.max(1, ...revenueByMonth.map((point) => point.gross));

  return (
    <section className="bg-background-50 border border-background-200 rounded-lg p-5 md:p-6">
      <div className="flex items-start justify-between gap-3">
        <div>
          <h2 className="font-heading text-xl text-foreground-950 font-semibold">Revenue analytics</h2>
          <p className="text-sm text-foreground-600 mt-1">Rolling 12 months · all farms</p>
        </div>
        <span className="text-right">
          <span className="block font-heading text-2xl font-semibold text-foreground-950">
            {formatCompactRupees(net)}
          </span>
          <span className="block text-[11px] text-foreground-500">net revenue</span>
        </span>
      </div>

      <div className="flex items-end gap-1.5 h-28 mt-6">
        {revenueByMonth.map((point) => (
          <div key={point.month} className="flex-1 flex flex-col items-center justify-end h-full">
            <div
              className="w-full max-w-[34px] mx-auto rounded-t bg-primary-400/80"
              style={{ height: `${Math.max(6, (point.gross / monthMax) * 100)}%` }}
              title={`${point.month}: ${formatRupees(point.gross)}`}
            ></div>
            <span className="text-[10px] text-foreground-500 mt-1.5">{point.month}</span>
          </div>
        ))}
      </div>

      <div className="mt-6 pt-5 border-t border-background-200 space-y-4">
        {rows.map((row) => (
          <div key={row.label}>
            <div className="flex items-center justify-between gap-3 mb-1.5">
              <span className="text-sm text-foreground-700">{row.label}</span>
              <span className="text-sm font-semibold text-foreground-950 whitespace-nowrap">
                {formatRupees(row.value)}
              </span>
            </div>
            <div className="h-2 rounded-full bg-background-100 overflow-hidden">
              <div
                className={`h-full rounded-full ${row.bar}`}
                style={{ width: `${Math.max(3, (row.value / max) * 100)}%` }}
              ></div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}